// extracted by mini-css-extract-plugin
export var button = "_g5-0";
export var donut = "_g5-1";
export var donutFill = "_g5-3";
export var donutTrack = "_g5-2";